import { store } from 'store';

import { ReducerActionRotaSP } from 'store/modules/types';
import { clearAuthToken } from 'store/modules/app/authToken/actions';
import { Types, LoginRequest } from './types';

export function logInRequest(
	token: string,
	payload: LoginRequest,
): ReducerActionRotaSP {
	return {
		type: Types.LOG_IN_REQUEST,
		token,
		payload,
	};
}

export function logInSuccess(payload: []): ReducerActionRotaSP {
	return {
		type: Types.LOG_IN_SUCCESS,
		payload,
	};
}

export function logInFailure(payload: []): ReducerActionRotaSP {
	return {
		type: Types.LOG_IN_FAILURE,
		payload,
	};
}

export function logInChangePassword(payload: {
	status: boolean;
	message: string;
}): ReducerActionRotaSP {
	return {
		type: Types.LOG_IN_CHANGE_PASSWORD,
		payload,
	};
}

export function logOffRequest(): ReducerActionRotaSP {
	return {
		type: Types.LOG_OFF_REQUEST,
		payload: null,
	};
}

export function logOffAndReloadRequest(): ReducerActionRotaSP {
	return {
		type: Types.LOG_OFF_AND_RELOAD_REQUEST,
		payload: null,
	};
}

export function logOffAndReloadRequestApi() {
	store.dispatch({
		type: Types.LOG_OFF_AND_RELOAD_REQUEST,
		payload: null,
	});
}

export function extenderTempoParaInatividade() {
	store.dispatch({
		type: Types.EXTENDER_TEMPO_PARA_INATIVIDADE,
		payload: null,
	});
}

export function logout() {
	store.dispatch({
		type: Types.LOG_OFF_REQUEST,
		payload: null,
	});
}

export function limpaLogin(): ReducerActionRotaSP {
	clearAuthToken();
	return {
		type: Types.LIMPA_LOGIN,
		payload: null,
	};
}

export function limpaLoginSemLimparAuthToken(): ReducerActionRotaSP {
	return {
		type: Types.LIMPA_LOGIN,
		payload: null,
	};
}

export function fixLogIn(payload: any): ReducerActionRotaSP {
	return {
		type: Types.FIX_LOG_IN,
		payload,
	};
}

export function lockUrl(payload: boolean): ReducerActionRotaSP {
	return {
		type: Types.LOCKED_URL_REQUEST,
		payload,
	};
}
